import { makeAutoObservable } from 'mobx'

import type { ModalsIds } from '../constants'

/**
 * context 안에 들어갈 modal 정보
 ** id: ModalsIds - modal을 유니크하게 관리하는 id
 ** Component: any - modal Component
 ** props?: any - modal props
 ** path?: string - modal이 open 되었을 때 path
 */
interface ModalData {
  id: ModalsIds
  Component: any
  path?: string
  props?: any
}

export class ModalStore {
  modals: ModalData[] = []

  constructor() {
    makeAutoObservable(this)
  }

  openModal = (modal: ModalData) => {
    this.modals = [...this.modals, { ...modal, path: location.pathname }]
  }

  closeModal = (id: ModalData['id']) => {
    this.modals = this.modals.filter((modal) => modal.id !== id)
  }
}
